import { createFileRoute } from '@tanstack/react-router'

import { SummaryPage } from '@/components/Public/Configurator/SummaryPage'

export const Route = createFileRoute('/public/configurator/summary')({
  component: SummaryPage,
})
